import img1 from '../images/items/montono-01.png'
import img2 from '../images/items/montono-02.png'
import img3 from '../images/items/montono-03.png'
import img4 from '../images/items/montono-04.png'
import img5 from '../images/items/montono-05.png'
import img6 from '../images/items/montono-06.png'
import img7 from '../images/items/montono-07.png'
import img8 from '../images/items/montono-08.png'
import img9 from '../images/items/montono-09.png'
import img10 from '../images/items/montono-10.png'
import img11 from '../images/items/montono-11.png'
import img12 from '../images/items/montono-12.png'
import img13 from '../images/items/montono-13.png'
import img14 from '../images/items/montono-14.png'
import img15 from '../images/items/montono-15.png'
import img16 from '../images/items/montono-16.png'
import img17 from '../images/items/montono-17.png'
import img18 from '../images/items/montono-18.png'
import img19 from '../images/items/montono-19.png'
import img20 from '../images/items/montono-20.png'
import img21 from '../images/items/montono-21.png'
import img22 from '../images/items/montono-22.png'
import img23 from '../images/items/montono-23.png'
import img24 from '../images/items/montono-24.png'
import img25 from '../images/items/montono-25.png'
import img26 from '../images/items/montono-26.png'
import img27 from '../images/items/montono-27.png'
import img28 from '../images/items/montono-28.png'
import img29 from '../images/items/montono-29.png'
import img30 from '../images/items/montono-30.png'



const dataMontono = [
    {
        img: img1,
        title: 'On Figure Product'
    },
    {
        img: img2,
        title: 'Tabletop Product'
    },
    {
        img: img3,
        title: 'Monteno item 3'
    },
    {
        img: img4,
        title: 'Monteno item 4'
    },
    {
        img: img5,
        title: 'Monteno item 5'
    },
    {
        img: img6,
        title: 'Monteno item 6'
    },
    {
        img: img7,
        title: 'Monteno item 7'
    },
    {
        img: img8,
        title: 'Monteno item 8'
    },
    {
        img: img9,
        title: 'Portraits'
    },
    {
        img: img10,
        title: 'Architecture'
    },
    {
        img: img11,
        title: 'Event Coverage'
    },
    {
        img: img12,
        title: 'Commercial'
    },
    {
        img: img13,
        title: 'Headshot Studio'
    },
    {
        img: img14,
        title: 'Editorial'
    },
    {
        img: img15,
        title: 'Editorial'
    },
    {
        img: img16,
        title: 'Editorial'
    },
    {
        img: img17,
        title: 'Editorial'
    },
    {
        img: img18,
        title: 'Editorial'
    },
    {
        img: img19,
        title: 'Editorial'
    },
    {
        img: img20,
        title: 'Editorial'
    },
    {
        img: img21,
        title: 'Editorial'
    },
    {
        img: img22,
        title: 'Editorial'
    },
    {
        img: img23,
        title: 'Editorial'
    },
    {
        img: img24,
        title: 'Editorial'
    },
    {
        img: img25,
        title: 'Editorial'
    },
    {
        img: img26,
        title: 'Editorial'
    },
    {
        img: img27,
        title: 'Editorial'
    },
    {
        img: img28,
        title: 'Editorial'
    },
    {
        img: img29,
        title: 'Eitorial'
    },
    {
        img: img30,
        title: 'Editorial'
    },
    

]

export default dataMontono;